import React from 'react'

import { Form, Col } from '_zari/core'

const NumeroOperacionFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='NUM. OPE.' htmlFor='input-numeroOperacion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputText
          id='input-numeroOperacion'
          name='input-numeroOperacion'
          disabled
          value={iValue}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroOperacionFormGroup)
